import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { authHeader } from '../../../../services/authHeader';
import BackButton from '../../../Shared/BackButton';
import FormFeedback from '../../../Shared/FormFeedback';
import PasswordInput from '../../../Shared/PasswordInput';
import styles from './ChangePassword.module.css';

const ChangePassword = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage(null);

        try {
            await axios.patch(`${process.env.REACT_APP_API_URL}/api/c/changepassword/`, {
                current_password: currentPassword,
                new_password: newPassword,
            }, authHeader());

            setCurrentPassword('');
            setNewPassword('');
            navigate(-1);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.response?.data?.detail || 'An unexpected error occurred.';
            setError(errorMessage);
        }
    };

    return (
        <div className={styles.container}>
            <BackButton />
            <h1 className={styles.title}>Change Password</h1>
            <form className={styles.form} onSubmit={handleSubmit}>
                <label className={styles.label}>
                    Current Password
                    <PasswordInput
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder="Enter current password"
                        required
                    />
                </label>
                <label className={styles.label}>
                    New Password
                    <PasswordInput
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter new password"
                        required
                    />
                </label>
                <button className={styles.submitButton} type="submit">Change Password</button>
            </form>
            <FormFeedback error={error} success={successMessage} />
        </div>
    );
};

export default ChangePassword;
